<template>
  <v-card>
    <v-progress-linear
      absolute
      :active="loading"
      indeterminate
      color="primary"
      bottom
    ></v-progress-linear>
    <v-card-title>
      <span class="headline">Create Category</span>
    </v-card-title>

    <v-card-text>
      <v-container>
        <category-form :data="data"></category-form>
      </v-container>
    </v-card-text>
    <form-errors :errors="errors"></form-errors>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="_close">Cancel</v-btn>
      <v-btn
        :disabled="loading"
        v-if="Object.values(item).length > 0"
        color="blue darken-1"
        text
        @click="update"
        >Update</v-btn
      >
      <v-btn
        :disabled="loading"
        v-else
        color="blue darken-1"
        text
        @click="create"
        >Create</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import FormErrors from '../../../components/FormErrors'
import CategoryForm from './CategoryForm'
import { axios } from '../../../utils'
export default {
  name: 'CategoryDialog',
  data() {
    return {
      data: {
        name: '',
        description: '',
        about: '',
        groups: [],
        keywords: [],
        featured: false,
        similarCategories: []
      },
      loading: false,
      errors: []
    }
  },
  props: ['close', 'categories', 'item'],
  components: {
    CategoryForm,
    FormErrors
  },
  mounted() {
    if (this.item.id) {
      this.loading = true
      console.log('getting category data for id ', this.item.id)
      axios
        .get('api/admin/categories/' + this.item.id)
        .then(res => {
          console.log(res.data)
          console.log('done')
          this.data = res.data
          this.loading = false
        })
        .catch(err => console.log(err))
    }
  },
  methods: {
    create() {
      this.loading = true
      console.log('creating new categories')
      axios
        .post('api/admin/categories/create', {
          name: this.data.name,
          description: this.data.description,
          about: this.data.about,
          active: this.data.active,
          groups: this.data.groups,
          keywords: this.data.keywords,
          featured: this.data.featured,
          similarCategories: this.data.similarCategories
        })
        .then(res => {
          console.log(res.data)
          console.log('done')

          this._close()
        })
        .catch(err => {
          if (err.response.status === 422) {
            this.errors = Object.values(err.response.data.errors)
          } else {
            console.log(err.response)
          }
        })
        .finally(() => (this.loading = false))
    },
    update() {
      this.loading = true
      console.log('updating category data for id ', this.item.id)
      axios
        .put(`api/admin/categories/${this.item.id}`, {
          name: this.data.name,
          description: this.data.description,
          about: this.data.about,
          active: this.data.active,
          groups: this.data.groups,
          keywords: this.data.keywords,
          featured: this.data.featured,
          similarCategories: this.data.similarCategories
        })
        .then(res => {
          console.log(res.data)
          console.log('done')
          this._close()
        })
        .catch(err => {
          if (err.response.status === 422) {
            this.errors = Object.values(err.response.data.errors)
          } else {
            console.log(err.response)
          }
        })
        .finally(() => (this.loading = false))
    },
    _close() {
      this.clearData()
      this.close()
    },
    clearData() {
      this.data = {
        name: '',
        description: '',
        about: '',
        active: false,
        groups: [],
        keywords: [],
        featured: false,
        similarCategories: []
      }
    }
  },
  watch: {}
}
</script>

<style lang="scss" scoped></style>
